import { useTranslation } from "react-i18next";
import logoProf from "../assets//images/navbar/logoProf.svg";
import avatar from "../assets/images/avatar.jpeg";
import { useDispatch, useSelector } from "react-redux";
import { SetSearch } from "../features/TopSearches/TopSearchesSlice";
import TopPicksSeacrh from "./TopPicksSeacrh";
import { Link, useNavigate } from "react-router-dom";
import {
  SetBottomSizeFilter,
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  getAllProductOnline,
  getLastDoc,
} from "../features/Products/ProductSlice";

function Search({ setShow, setSeacrhDrop }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { topSearches } = useSelector((store) => store.topsearches);
  const navigate = useNavigate();
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyle = {};
  }

  return (
    <>
      <div className="searchtitle pt-4 pb-4" style={arabStyle}>
        {t("MOSTSEARCHED")}
      </div>
      {topSearches.map((search) => (
        <div>
          <div
            className="searchtxt pt-2 pb-2"
            onClick={() =>
              dispatch(SetSizeFilter([])) &
              dispatch(SetTopSizeFilter([])) &
              dispatch(SetBottomSizeFilter([])) &
              dispatch(getAllProductOnline([])) &
              dispatch(getLastDoc(null)) &
              SetSelectdPage(0) &
              dispatch(SetSearch(search.text)) &
              navigate("/products") &
              setSeacrhDrop(false)
            }
          >
            {search.text}
          </div>
        </div>
      ))}
    </>
  );
}

export default Search;
